export class AddprojectCycleConstants {
    static COMPONENT_NAME = "Add project cycle";
}
